import React from "react";
import { Controller } from "react-hook-form";
import withLabelAndError from "../withLabelAndError";
import { Slider as MUISlider, TextField, Box } from "@mui/material";
import { combineClasses } from "@/lib/utils";
import styles from "./Slider.module.scss";
import {
  InputControlProps,
  WithLabelAndErrorComponent,
} from "@/types/formControls";

interface SliderControlProps extends InputControlProps {
  min?: number;
  max?: number;
  step?: number;
}

const Slider: React.FC<SliderControlProps> = ({
  control,
  validations,
  name,
  error,
  className,
  min = 0,
  max = 100,
  step = 1,
  ...props
}) => {
  const renderSlider = (field: any) => {
    const value: [number, number] = Array.isArray(field.value)
      ? field.value
      : [min, max];

    const [minValue, maxValue] = value;

    const handleSliderChange = (_: Event, newValue: number | number[]) => {
      if (Array.isArray(newValue)) {
        field.onChange(newValue as [number, number]);
      }
    };

    const handleMinChange = (val: number) => {
      field.onChange([Math.min(val, maxValue), maxValue]);
    };

    const handleMaxChange = (val: number) => {
      field.onChange([minValue, Math.max(val, minValue)]);
    };

    return (
      <Box className={combineClasses(styles.sliderWrapper, className)}>
        {/* Min / Max Pickers */}
        {/* <Box display="flex" gap={2} mb={1}>
          <TextField
            label="Min"
            size="small"
            type="number"
            value={minValue}
            onChange={(e) => handleMinChange(Number(e.target.value))}
            inputProps={{ min, max: maxValue, step }}
            error={!!error}
            fullWidth
          />

          <TextField
            label="Max"
            size="small"
            type="number"
            value={maxValue}
            onChange={(e) => handleMaxChange(Number(e.target.value))}
            inputProps={{ min: minValue, max, step }}
            error={!!error}
            fullWidth
          />
        </Box> */}

        {/* Slider */}
        <MUISlider
          {...props}
          value={[minValue, maxValue]}
          onChange={handleSliderChange}
          min={min}
          max={max}
          step={step}
          valueLabelDisplay="auto"
          className={combineClasses(styles.slider, error && styles.error)}
        />
      </Box>
    );
  };

  return (
    <Controller
      control={control}
      name={name}
      rules={validations}
      render={({ field }) => renderSlider(field)}
    />
  );
};

const SliderWithLabelAndError = withLabelAndError(
  Slider as WithLabelAndErrorComponent,
);

export default SliderWithLabelAndError;
export { Slider };
